import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

// Auto-refresh member session: on 401 from /members/* endpoints, try one token refresh then retry
let refreshPromise = null;
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  const url = cfg.url || "";
  const skip = ["/members/login", "/members/register", "/members/refresh", "/members/reset-password", "/members/forgot-password"];
  if (error.response?.status === 401 && url.startsWith("/members") && !skip.some((s) => url.includes(s)) && !cfg._retried) {
    cfg._retried = true;
    try {
      refreshPromise = refreshPromise || api.post("/members/refresh");
      await refreshPromise;
      refreshPromise = null;
      return api.request(cfg);
    } catch { refreshPromise = null; }
  }
  return Promise.reject(error);
});

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || "Invalid input";
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const MemberProvider = ({ children }) => {
  const [member, setMember] = useState(null); // null = checking, false = signed out

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/members/me");
        setMember(data);
      } catch {
        try {
          const { data } = await api.post("/members/refresh");
          setMember(data);
        } catch { setMember(false); }
      }
    })();
  }, []);

  const logout = async () => {
    try { await api.post("/members/logout"); } catch (e) { console.warn("Logout request failed", e); }
    setMember(false);
  };

  return <Ctx.Provider value={{ member, setMember, logout }}>{children}</Ctx.Provider>;
};

export const useMember = () => useContext(Ctx);
